import $ from 'jquery';
import autosize from 'autosize';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';
import 'next/stylesheets/components/calendar-todo-form.scss';

Component('tr-calendar-todo-form', {
  mixins: [eventListenerMixin],

  properties: {
    date: String,
    submitting: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.contentInput = this.querySelector('.todo-content-form-input textarea');

    this.initAutosize();

    this.listenTo(this.contentInput, {
      compositionstart: () => { this.isInputComposing = true; },
      compositionend: () => { this.isInputComposing = false; },
      keydown: this.handleContentKeydown.bind(this),
    });
    this.listenTo(document, 'click', this.handleClick.bind(this));
    $(this).on('ajax:success', '.tr-form', this.handleSuccess.bind(this));
    $(this).on('ajax:beforeSend', '.tr-form', () => { this.classList.add('submiting'); });
    $(this).on('ajax:complete', '.tr-form', () => { this.classList.remove('submiting'); });
  },

  handleSuccess(event, result) {
    const { todo } = result;
    this.namespacedTrigger('addTodoSuccess', {
      detail: { todo },
      bubbles: true,
    });
    this.remove();
  },

  initAutosize() {
    this.contentInput.rows = 1;
    autosize(this.contentInput);
    this.contentInput.focus();
  },

  handleClick(event) {
    const { target } = event;
    if (this.contains(target) || closest(target, '.mdc-menu-surface')) return;
    this.submit();
  },

  handleContentKeydown(event) {
    if (this.isInputComposing || event.isComposing || event.keyCode === 229) return;

    const isEnter = event.key === 'Enter' || event.keyCode === 13;
    const isEscape = event.key === 'Escape' || event.keyCode === 27;

    if (isEnter) {
      event.preventDefault();
      event.stopPropagation();
      this.submit();
    } else if (isEscape) {
      event.stopPropagation();
      this.contentInput.value = '';
      this.remove();
    }
  },

  submit() {
    if (this.submitting) return;
    const { value } = this.contentInput;
    if (value) {
      this.submitting = true;
      $(this.querySelector('.tr-form')).trigger('submit');
    } else {
      this.remove();
    }
  },

  disconnected() {
    this.submitting = false;
    this.stopListening();
  },
});
